import api from '..'

export async function deleteBidRung(id: number | string): Promise<void> {
  await api.delete(`/bid-rungs/${id}`)
}
